import { Component, Input } from '@angular/core';
import { DsChipColorVariant, DsChipIconPosition, DsColors, Icons, IconStyles } from '@levelaccess/design-system';

import { $severity } from '../../../../shared/constants/accessibility';
import { ICustomSeveritiesMap, ICustomSeverity } from '../../../../shared/interfaces/tenant.interface';
import { $customSeverity } from '../../../../shared/constants/tenant';
import { SharedTextUtility } from '../../../../shared/utils/text.utility';
import { SeverityChipUtility } from '../../utility/severity-chip.utility';

@Component({
  selector: 'app-custom-rule-severity',
  templateUrl: './custom-rule-severity.component.html',
  styleUrls: ['./custom-rule-severity.component.scss'],
  standalone: false,
})
export class CustomRuleSeverityComponent {
  protected readonly Icons: typeof Icons = Icons;
  protected readonly IconStyles: typeof IconStyles = IconStyles;
  protected readonly colors: typeof DsColors = DsColors;
  protected readonly DsChipColorVariant: typeof DsChipColorVariant = DsChipColorVariant;
  protected readonly DsChipIconPosition: typeof DsChipIconPosition = DsChipIconPosition;

  @Input() public severity: $severity;
  @Input() public customSeverities: ICustomSeveritiesMap;

  public $severity: typeof $severity;
  constructor() {
    this.$severity = $severity;
  }

  protected get severityText(): string {
    return SharedTextUtility.capitalize(this.customSeverities?.get(this.severity)?.[$customSeverity.label]);
  }

  protected get severityIcon(): Icons {
    return SeverityChipUtility.getIcon(this.severity, {
      customSeverityKeysSortedByRank: this.customSeverityKeysSortedByRank,
    });
  }

  protected get severityChipVariant(): DsChipColorVariant {
    return SeverityChipUtility.getChipVariant(this.severity);
  }

  protected get severityIconColor(): keyof typeof DsColors {
    return SeverityChipUtility.getIconColor(this.severity);
  }

  private get customSeverityKeysSortedByRank(): $severity[] | undefined {
    if (!this.customSeverities) {
      return undefined;
    }

    return ([$severity.custom1, $severity.custom2] as $severity[])
      .filter((key: $severity): boolean => Boolean(this.customSeverities.get(key)))
      .sort((firstKey: $severity, secondKey: $severity): number => {
        const firstSeverity: ICustomSeverity = this.customSeverities.get(firstKey);
        const secondSeverity: ICustomSeverity = this.customSeverities.get(secondKey);
        return secondSeverity[$customSeverity.rank] - firstSeverity[$customSeverity.rank];
      });
  }
}
